export interface DividendYieldInput {
  capital: number;
  /** Angenommene Dividendenrendite als Dezimalzahl (0,04 = 4 %). */
  yieldRate: number;
}

export interface DividendYieldResult {
  annualPayout: number;
  monthlyPayout: number;
  quarterlyPayout: number;
}

/**
 * Rein hypothetischer Dividendenrendite-Rechner (backlog.md -> Aktienfinder-Benchmark,
 * "Dividendenrendite-Rechner ohne Login: Kapital + Rendite -> monatliche Ausschüttung") -
 * bewusst ohne Ticker-Bezug, nur eine angenommene Rendite auf ein angenommenes Kapital.
 * Reine Funktion, kein I/O.
 */
export function computeDividendYieldPayout(input: DividendYieldInput): DividendYieldResult | undefined {
  const { capital, yieldRate } = input;
  if (!Number.isFinite(capital) || !Number.isFinite(yieldRate) || capital < 0 || yieldRate < 0) {
    return undefined;
  }
  const annualPayout = capital * yieldRate;
  return { annualPayout, monthlyPayout: annualPayout / 12, quarterlyPayout: annualPayout / 4 };
}
